import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getClasses } from "../services/api";
import PageHero from "../components/PageHero";

function formatDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("es-PE", {
    year: "numeric", month: "short", day: "numeric",
  });
}

export default function Classes() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getClasses()
      .then(setClasses)
      .catch(() => setError("No se pudieron cargar las clases."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <PageHero
        section="clases"
        title="Clases"
        backBtn={{ label: "Inicio", onClick: () => navigate("/") }}
      />

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "1.5rem 2rem" }}>
        {error && <p style={{ color: "#c0392b" }}>{error}</p>}

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "1.2rem",
        }}>
          {loading
            ? [1, 2, 3, 4, 5, 6].map((n) => (
                <div className="skel" key={n} style={{ minHeight: 140 }}>
                  <div className="skel-line" style={{ width: "30%", height: 10, marginBottom: 10 }} />
                  <div className="skel-line" style={{ width: "80%", height: 14, marginBottom: 8 }} />
                  <div className="skel-line" style={{ width: "100%", height: 11, marginBottom: 6 }} />
                  <div className="skel-line" style={{ width: "65%", height: 11 }} />
                </div>
              ))
            : classes.map((c, i) => (
                <div
                  key={c.id}
                  className="card"
                  onClick={() => navigate(`/clases/${c.id}`)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && navigate(`/clases/${c.id}`)}
                  style={{
                    cursor: "pointer",
                    transition: "box-shadow .18s, transform .18s",
                    display: "flex",
                    flexDirection: "column",
                    gap: ".5rem",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "0 4px 18px rgba(14,138,138,.13)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "var(--teal)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "";
                    e.currentTarget.style.transform = "";
                    e.currentTarget.style.borderColor = "";
                  }}
                >
                  <span style={{
                    fontFamily: "var(--font-display)",
                    fontSize: "0.68rem",
                    fontWeight: 700,
                    color: "var(--teal)",
                    letterSpacing: 1,
                    textTransform: "uppercase",
                  }}>
                    Clase {i + 1}
                  </span>
                  <h2 style={{
                    fontFamily: "var(--font-display)",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    color: "var(--charcoal)",
                    lineHeight: 1.4,
                  }}>
                    {c.title}
                  </h2>
                  <p style={{
                    fontSize: "0.82rem",
                    color: "var(--text-muted)",
                    lineHeight: 1.6,
                    flex: 1,
                  }}>
                    {c.description}
                  </p>
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: ".3rem",
                  }}>
                    <span style={{ fontSize: "0.7rem", color: "var(--text-light)" }}>
                      {formatDate(c.created_at)}
                    </span>
                    <span style={{ color: "var(--teal)", fontSize: "1rem" }}>→</span>
                  </div>
                </div>
              ))
          }
        </div>
      </div>
    </div>
  );
}